module.exports={
    "version": 9,
    "compilerVersion": "1.19.0+commit.72eaeba",
    "contract": "NftUnlockContractCheck",
    "md5": "666adb8e966719fe38379e24d40dda3a",
    "structs": [
        {
            "name": "LockingScriptParts",
            "params": [
                {
                    "name": "code",
                    "type": "bytes"
                },
                {
                    "name": "data",
                    "type": "bytes"
                }
            ],
            "genericTypes": []
        },
        {
            "name": "OpPushData",
            "params": [
                {
                    "name": "len",
                    "type": "int"
                },
                {
                    "name": "value",
                    "type": "int"
                }
            ],
            "genericTypes": []
        },
        {
            "name": "VarIntData",
            "params": [
                {
                    "name": "len",
                    "type": "int"
                },
                {
                    "name": "value",
                    "type": "int"
                }
            ],
            "genericTypes": []
        },
        {
            "name": "TxInputProof",
            "params": [
                {
                    "name": "hashProof",
                    "type": "bytes"
                },
                {
                    "name": "txHash",
                    "type": "bytes"
                },
                {
                    "name": "outputIndexBytes",
                    "type": "bytes"
                },
                {
                    "name": "sequenceBytes",
                    "type": "bytes"
                }
            ],
            "genericTypes": []
        },
        {
            "name": "TxOutputProof",
            "params": [
                {
                    "name": "txHeader",
                    "type": "bytes"
                },
                {
                    "name": "hashProof",
                    "type": "bytes"
                },
                {
                    "name": "satoshiBytes",
                    "type": "bytes"
                },
                {
                    "name": "scriptHash",
                    "type": "bytes"
                }
            ],
            "genericTypes": []
        }
    ],
    "library": [
        {
            "name": "ProtoHeader",
            "params": [],
            "properties": [],
            "genericTypes": []
        },
        {
            "name": "AmountCheckProto",
            "params": [],
            "properties": [],
            "genericTypes": []
        },
        {
            "name": "NftProto",
            "params": [],
            "properties": [],
            "genericTypes": []
        },
        {
            "name": "TxUtil",
            "params": [],
            "properties": [],
            "genericTypes": []
        }
    ],
    "alias": [],
    "abi": [
        {
            "type": "function",
            "name": "unlock",
            "index": 0,
            "params": [
                {
                    "name": "txPreimage",
                    "type": "SigHashPreimage"
                },
                {
                    "name": "prevouts",
                    "type": "bytes"
                },
                {
                    "name": "nftInputIndex",
                    "type": "int"
                },
                {
                    "name": "nftScript",
                    "type": "bytes"
                },
                {
                    "name": "nftTxHeader",
                    "type": "bytes"
                },
                {
                    "name": "nftTxHashProof",
                    "type": "bytes"
                },
                {
                    "name": "nftSatoshiBytes",
                    "type": "bytes"
                },
                {
                    "name": "nOutputs",
                    "type": "int"
                },
                {
                    "name": "txNftOutputIndex",
                    "type": "int"
                },
                {
                    "name": "nftOutputAddress",
                    "type": "bytes"
                },
                {
                    "name": "nftOutputSatoshis",
                    "type": "int"
                },
                {
                    "name": "otherOutputArray",
                    "type": "bytes"
                }
            ]
        },
        {
            "type": "constructor",
            "params": []
        }
    ],
    "stateProps": [],
    "buildType": "debug",
    "file": "file:///Users/ivan/Codes/blockchain/meta-contract/src/mcp01/contract/nft/nftUnlockContractCheck.scrypt",
    "hex": "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",
    "sourceMapFile": "file:///Users/ivan/Codes/blockchain/meta-contract/src/mcp01/contract-desc/nftUnlockContractCheck.map.json"
}